<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.away' | translate | uppercase }}
</h1>
<div mat-dialog-content>
  <form [formGroup]="awayForm">
    <mat-form-field appearance="fill" class="full-width-input">
      <mat-label>{{ 'NGX-MESSAGING.until' | translate }} ({{ 'NGX-MESSAGING.date' | translate }})</mat-label>
      <input
        matInput
        (keydown)="(false)"
        (click)="picker.open()"
        [matDatepicker]="picker"
        [matDatepickerFilter]="disablePastDates"
        formControlName="toDay" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="fill" class="full-width-input">
      <mat-label>{{ 'NGX-MESSAGING.until' | translate }} ({{ 'NGX-MESSAGING.time' | translate }})</mat-label>
      <input
        matInput
        (keydown)="(false)"
        formControlName="toHour"
        (click)="timepicker.open()"
        [matTimepicker]="timepicker" />

      <mat-timepicker-toggle matSuffix [for]="timepicker"></mat-timepicker-toggle>
      <mat-timepicker #timepicker mode="input"></mat-timepicker>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width-input 3">
      <mat-label>{{ 'NGX-MESSAGING.type' | translate }}</mat-label>
      <mat-select placeholder="Type" formControlName="type">
        <mat-option [value]="'DELEGATION'" (click)="updateValidators('DELEGATION')">
          {{ 'NGX-MESSAGING.delegation' | translate }}
        </mat-option>
        <mat-option [value]="'MESSAGE'" (click)="updateValidators('MESSAGE')">
          {{ 'NGX-MESSAGING.custom_message' | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    @if(awayForm.get('type')?.value === 'MESSAGE'){
    <mat-form-field appearance="fill" class="full-width-input">
      <mat-label>{{ 'NGX-MESSAGING.message' | translate }}</mat-label>
      <textarea
        rows="1"
        spellcheck="true"
        minlength="1"
        (input)="autoResizeTextArea()"
        matInput
        formControlName="message"
        #myTextarea></textarea>
    </mat-form-field>
    } @if(awayForm.get('type')?.value === 'DELEGATION'){
    <mat-form-field appearance="fill" class="full-width-input">
      <mat-label>{{ 'NGX-MESSAGING.delegate_to' | translate }} </mat-label>
      <input matInput formControlName="user" [matAutocomplete]="auto" />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText" multiple>
        @for (option of users(); track option.uid) {
        <mat-option [value]="option">
          {{ option.displayName }}
        </mat-option>
        } @if (loadingUsers()) {
        <mat-option> {{ 'NGX-MESSAGING.searching' | translate }} </mat-option>
        } @if(!loadingUsers() && !users().length && !awayForm.get('user')?.value?.uid){
        <mat-option> {{ 'NGX-MESSAGING.CHAT.noResultsFound' | translate }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    } @if(awayForm.hasError('invalidDateTime')){
    <mat-error> {{ 'NGX-MESSAGING.time_cannot_be_less_than_current_time' | translate }} </mat-error>
    }
  </form>
</div>
<div mat-dialog-actions align="end">
  @if(user()?.away){
  <button mat-raised-button class="cancel-button" (click)="cancel()">
    {{ 'NGX-MESSAGING.back_online' | translate }}
  </button>
  } @else {
  <button
    mat-raised-button
    class="chat-input__button"
    color="primary"
    (click)="save()"
    [disabled]="!awayForm.valid || isLoadingAway()">
    {{ 'NGX-MESSAGING.set_yourself_away' | translate }}
  </button>
  }
</div>
